export const ISSUANCE_ELIGIBILITY_REASONS = {
  SIMILAR_PRODUCT_EXISTS: 'SIMILAR_PRODUCT_EXISTS',
  ACCOUNT_TYPE_INVALID: 'ACCOUNT_TYPE_INVALID',
} as const

export type IssuanceEligibilityReason = (typeof ISSUANCE_ELIGIBILITY_REASONS)[keyof typeof ISSUANCE_ELIGIBILITY_REASONS]
